module.exports = __webpack_public_path__ + "img/ltktravel-4x.bd5a0f2.jpg";